import { useState, useEffect } from "react";
import { useSelector } from "react-redux";
//import { Link } from "react-router-dom";
import ReactLoading from 'react-loading';
import { Box, Select, MenuItem, Tooltip, Grid, Button, Stack, Tabs, Tab, useTheme } from "@mui/material";
//import { GridView, ViewList } from '@mui/icons-material';

import './media.scss';
import PanoramaFishEyeOutlinedIcon from '@mui/icons-material/PanoramaFishEyeOutlined';
import RadioButtonCheckedOutlinedIcon from '@mui/icons-material/RadioButtonCheckedOutlined';
//import FormatListBulletedOutlinedIcon from '@mui/icons-material/FormatListBulletedOutlined';
//import WindowOutlinedIcon from '@mui/icons-material/WindowOutlined';
import SkipNextIcon from '@mui/icons-material/SkipNext';
import SkipPreviousIcon from '@mui/icons-material/SkipPrevious';

import GridItem from "./GridItem"
import ListItem from "./ListItem"
import { getExports, getAssets, getCompress, getTranscodes, getWorkspacesList } from '../../../../axios/ApiProvider';
import { copyObject } from "../../dashboard.config";
import { NoContent } from "../../../no-content/NoContent";

const BASE_BACKEND_URL = process.env.REACT_APP_BASE_BACKEND_URL;

export const Media = () => {
  const theme = useTheme();
  const languageStrs = useSelector((store) => store.editdata.languageStrs);
  const [sortKey, setSortKey] = useState(1);
  const [toolbarStyle, SetToolbarStyle] = useState('grid');
  const ToolbarStyleChange = () => { SetToolbarStyle(toolbarStyle === 'grid' ? 'list' : 'grid'); }

  const [isLoading, setIsLoading] = useState(true);
  const [nextPageUrl, setNextPageUrl] = useState(null);
  const [pretPageUrl, setPretPageUrl] = useState(null);
  const [mediaItems, setMediaItems] = useState([]);
  const [sortedArr, setSortedArr] = useState([]);
  const [mediaType, setMediaType] = useState('exports');
  const [workspaceType, setWorkspaceType] = useState('all');
  const [workspacesList, setWorkspacesList] = useState([]);
  const [reloadeUrl, setReloadeUrl] = useState(BASE_BACKEND_URL + '/user/exports/');

  useEffect(() => {
    getWorkSpaces()
  }, [])

  useEffect(() => {
    if (workspaceType === 'all') {
      GetMedia(BASE_BACKEND_URL + '/user/exports/');
      setReloadeUrl(BASE_BACKEND_URL + '/user/exports/')
    } else {
      GetMedia(BASE_BACKEND_URL + '/user/exports/workspace/' + workspaceType)
      setReloadeUrl(BASE_BACKEND_URL + '/user/exports/workspace/' + workspaceType)
    }
    handleTabChange(null, "exports");
  }, [workspaceType])

  useEffect(() => {
    let tempArr = copyObject(mediaItems)

    tempArr.sort((a, b) => {
      let returnValue;
      if (sortKey === 1) returnValue = a.title - b.title
      else if (sortKey === 2) returnValue = (+ new Date(a.created_at)) - (+ new Date(b.created_at))
      else if (sortKey === 3) returnValue = (+ new Date(b.created_at)) - (+ new Date(a.created_at))
      return returnValue
    })

    setSortedArr(tempArr)
  }, [mediaItems, sortKey])

  const getWorkSpaces = async () => {
    try {
      const result = await getWorkspacesList()

      if (result.state === 'success') {
        if (typeof result.data === 'object') {
          setWorkspacesList(result.data)
        }
      }
    } catch (err) {
      console.log(err.message)
    }
  }

  const GetMedia = async (url) => {
    setIsLoading(false);
    let result;
    
    switch(mediaType) {
      case 'exports':
        result = await getExports(url);
        break;
      case 'assets':
        result = await getAssets(url);
        break;
      case 'compress':
        result = await getCompress(url);
        break;
      case 'transcodes':
        result = await getTranscodes(url);
        break;
      default:
        result = await getExports(url);
    }

    if (result.state === 'success') {
      setMediaItems(result.data.results || []);
      setNextPageUrl(result.data.next);
      setPretPageUrl(result.data.previous);
    } else {
      setMediaItems([]);
    }
    setIsLoading(true);
  };

  const nextPage = () => { 
    GetMedia(nextPageUrl);
    setReloadeUrl(nextPageUrl)
  }

  const prePage = () => {
    GetMedia(pretPageUrl);
    setReloadeUrl(pretPageUrl)
  }

  const handleTabChange = (event, newValue) => {
    setMediaType(newValue);
    if (newValue === 'exports') getExportsMedia();
    else if (newValue === 'assets') getAssetsMedia();
    else if (newValue === 'compress') getCompressMedia();
    else if (newValue === 'transcodes') getTranscodesMedia();
  };

  const getExportsMedia = () => {
    if(workspaceType !== 'all') {
      GetMedia(BASE_BACKEND_URL + '/user/exports/workspace/' + workspaceType);
      setReloadeUrl(BASE_BACKEND_URL + '/user/exports/workspace/' + workspaceType);
      return;
    }
    GetMedia(BASE_BACKEND_URL + '/user/exports/');
    setReloadeUrl(BASE_BACKEND_URL + '/user/exports/');
  }

  const getAssetsMedia = () => {
    if(workspaceType !== 'all') {
      GetMedia(BASE_BACKEND_URL + '/user/assets/workspace/' + workspaceType);
      setReloadeUrl(BASE_BACKEND_URL + '/user/assets/workspace/' + workspaceType);
      return;
    }
    GetMedia(BASE_BACKEND_URL + '/user/assets/');
    setReloadeUrl(BASE_BACKEND_URL + '/user/assets/');
  }

  const getCompressMedia = () => {
    if(workspaceType !== 'all') {
      GetMedia(BASE_BACKEND_URL + '/user/compresss/workspace/' + workspaceType);
      setReloadeUrl(BASE_BACKEND_URL + '/user/compresss/workspace/' + workspaceType);
      return;
    }
    GetMedia(BASE_BACKEND_URL + '/user/compresss/');
    setReloadeUrl(BASE_BACKEND_URL + '/user/compresss/');
  }

  const getTranscodesMedia = () => {
    if(workspaceType !== 'all') {
      GetMedia(BASE_BACKEND_URL + '/user/converts/workspace/' + workspaceType);
      setReloadeUrl(BASE_BACKEND_URL + '/user/converts/workspace/' + workspaceType);
      return;
    }
    GetMedia(BASE_BACKEND_URL + '/user/converts/');
    setReloadeUrl(BASE_BACKEND_URL + '/user/converts/');
  }

  const workspaceUUIDchange = async ({ target }) => {
    const uuid = target.value
    const checkUuid = workspacesList.find((workspace) => (
      workspace.uuid === uuid
    ))

    if (checkUuid || uuid === 'all') {
      setWorkspaceType(uuid)
    }
  }

  const handleOnDelete = () => {
    GetMedia(reloadeUrl)
  }

  return (
    <Box className="custom-projects-wrapper">
      <Box
        className="custom-projects-toolbar-section"
        sx={{
          borderBottom: "none !important"
        }}
      >
        <Box className="toolbar-Breadcrumbs-contain">
          <Tabs
            value={mediaType}
            onChange={handleTabChange}
            variant="scrollable"
            scrollButtons="auto"
            TabIndicatorProps={{
              sx: {
                backgroundColor: theme.palette.mode === 'light' ? '#0d85a1' : '#17d3ff',
              },
            }}
            sx={{
              '& .MuiTab-root.Mui-selected': {
                color: theme.palette.mode === 'light' ? '#0d85a1' : '#17d3ff',
              },
              '& .MuiTab-root': {
                color: theme.palette.mode === 'dark' ? 'rgba(255,255,255,0.7)' : '#1b1c1c',
              },
            }}
          >
            <Tab label="Exports" value="exports" />
            <Tab label="Assets" value="assets" />
            <Tab label="Compress" value="compress" />
            <Tab label="Transcodes" value="transcodes" />
          </Tabs>
        </Box>

      </Box>
        <Box className='projects-next-preview-btn' paddingBottom={1.5}>
          <Stack direction="row" spacing={2}>
            <Button onClick={prePage} variant="outlined" startIcon={<SkipPreviousIcon />} disabled={!!pretPageUrl ? false : true}>
              {languageStrs.previous}
            </Button>

            <Button onClick={nextPage} variant="outlined" endIcon={<SkipNextIcon />} disabled={!!nextPageUrl ? false : true}>
              {languageStrs.next}
            </Button>
          </Stack>
        </Box>

      <Box className="custom-projects-contents-section">
        {isLoading && sortedArr.length === 0 && 
         <NoContent />
        } 
        {sortedArr.length !== 0 &&
          <>
          {toolbarStyle === 'grid' ? (
            <Box className="projects-container">
              <Grid container spacing={2}>
                {sortedArr.map((item, index) => (
                  <Grid item xs={12} sm={6} md={6} lg={4} xl={2.4} key={index}>
                    <GridItem onDelete={handleOnDelete} itemData={item} />
                  </Grid>
                ))}
              </Grid>
            </Box>
          ) : (
            <Box className="list-projects-container">
              <Box className="projects-header-wrapper">
                <Box className="projects-header-NameTableCell1"></Box>
                <Box className="projects-header-NameTableCell1">{languageStrs.name}</Box>
                <Box className="projects-header-NameTableCell2">{languageStrs.status}</Box>
                <Box className="projects-header-NameTableCell3">{languageStrs.data_modified}</Box>
                <Box className="projects-header-NameTableCell4"></Box>
              </Box>

              {sortedArr.map((item, index) => (
                <ListItem onDelete={handleOnDelete} itemData={item} key={index} />
              ))}
            </Box>
          )}
          </>
        }
      </Box>
        
        {
          !isLoading && (
            <Box className='absolute top-1/2 left-1/2 -translate-x-1/2'>
              <ReactLoading type={'spinningBubbles'} color='rgb(53 126 221)' height={100} width={100} />
            </Box>
          )
        }

    </Box>
  );
};